import axios from 'axios';
import { type IRespuestaApiObjeto } from '../../globales/interfaces';
import type { IUsuarioAutenticado } from './entidades/IUsuarioAutenticado';
import type { IUsuarioCredencial } from './entidades/IUsuarioCredencial';

// Modelo de Autenticación
class ModeloAutenticacion {
    
    constructor() {
        // El baseUrl se obtiene de la configuración centralizada
    }

    async iniciarSesion(credenciales: IUsuarioCredencial): Promise<IRespuestaApiObjeto<IUsuarioAutenticado>> {
        const { data } = await axios.post(
            `${import.meta.env.VITE_API_URL_CONEKTAPP}/api/Login/Autenticar`,
            credenciales,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        // const data: IRespuestaApiObjeto<IUsuarioAutenticado> = {
        //     Data: {

        //         Email: "julianaandrea1414@gmail.com",
        //         Expiration: "2025-09-19T14:14:07.288Z",
        //         Id: 2,
        //         NombreCompleto: "Juliana Andrea Melo Guerrero",
        //         Permisos: [],
        //         Rol: [],
        //         Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyMjI4ODIiLCJub21icmUiOiJKdWxpYW5hIE0iLCJ1c3VhcmlvIjoiaml1bGlhbm14ZyIsImVtYWlsIjoiam9obi5kb2VAZ21haWwuY29tIiwiaWRQZXJmaWwiOiIxIiwiZXhwIjoxNzAxMDg5NjAwfQ.lXhH0hfFhD4dC3v8oC6ek0Rgf0-7L1nldoJfFqFoZB4"

        //     },
        //     Messages: [],
        //     NotificationType: EnumTipoNotificacion.Success,
        //     Pagination: {
        //         HasNext: false,
        //         HasPrevious: false,
        //         Page: 1,
        //         Size: 10,
        //         Total: 1,
        //         TotalPages: 1
        //     }
        // }


        return data;


    }

    // Método para cerrar sesión (solo limpia el frontend)
    async cerrarSesion(): Promise<{ success: boolean; message?: string }> {
        try {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');

            return {
                success: true,
                message: 'Sesión cerrada exitosamente'
            };

        } catch (error) {
            console.error('Error al cerrar sesión:', error);
            return {
                success: false,
                message: 'Error al cerrar sesión'
            };
        }
    }

}

export default ModeloAutenticacion;
